module.exports = __webpack_public_path__ + "static/img/1080-1920-4.776fe2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tht/1080-1920-4.png
// module id = 1Zbb
// module chunks = 0